export default "__VITE_ASSET__DkjMHizu__"